import { useFragmentFromStore } from '@smx-ui-model/hooks/use-fragment-from-store';
import { ModelType } from '@smx-ui-model/types';
import { useLazyLoadQuery } from 'react-relay';
import { memo } from 'react';

export interface DynamicListLoaderProps {
    model: ModelType<any>;
    input?: any;
    onChanged: (data: any) => void;
}

export const DynamicListLoader: React.FC<DynamicListLoaderProps> = memo(({ model, onChanged, input = {} }) => {
    const resultEntityList = useLazyLoadQuery(
        model.queryList!,
        { input, first: 20 },
        { fetchPolicy: 'store-or-network' },
    );

    onChanged(useFragmentFromStore(resultEntityList) as any);

    return null;
});
